import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { unitStats } from '../../../stats';

export const forestReducer = (scratch: StatsSnapshot) => {
  // const garrison = scratch.generators.garrison;
  const stats = unitStats.forest;

  const generated = stats.buildingsGeneration ?? 0;

  scratch.generators.outpost.owned += generated;

  return;
};
